module.exports = __webpack_public_path__ + "components/country-flag/static/vg-b0a9f07f495cb6d445747883d54ce660.svg";